import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
};

/** Styled like a stopwatch readout: tabular digits on navy, highlighter numbers. */
export function Countdown({
  size = 'lg'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-113" data-mp="3h0z2ivra3ex2">
      {units.map(unit => <div key={unit.label} className={`rounded-xl border border-navy-line bg-navy-card text-center tabular-nums text-hl ${isLarge ? 'min-w-[74px] px-4 py-3 sm:min-w-[92px] sm:px-6 sm:py-4' : 'min-w-[58px] px-3 py-2'}`} data-id="element-114" data-mp="373kot3wqp48g">
          <div className={`font-display font-bold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-115" data-mp="xzvf74p2cnwy">
            {unit.value}
          </div>
          <div className={`mt-1 font-bold uppercase tracking-widest text-chalk/60 ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-116" data-mp="17qq46gtp21m3">
            {unit.label}
          </div>
        </div>)}
    </div>;
}